import type { PaletteMode } from '@mui/material';

export const getPalette = (mode: PaletteMode) => ({
  mode,
  ...(mode === 'light'
    ? {
        // Light mode - Pagali Brand Colors (pastel tones)
        primary: {
          main: '#6233A0', // Pagali Purple (unified)
          light: '#9060CB',
          dark: '#3B1A7A',
          contrastText: '#fff',
        },
        secondary: {
          main: '#B4BF09', // Pagali Lime
          light: '#CDD154',
          dark: '#8A9307',
          contrastText: '#fff',
        },
        success: {
          main: '#28A745',
          light: '#D4EDDA',
          dark: '#1E7E34',
          contrastText: '#fff',
        },
        warning: {
          main: '#FFC107',
          light: '#FFF3CD',
          dark: '#D4A106',
          contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        error: {
          main: '#DC3545',
          light: '#F8D7DA',
          dark: '#B02A37',
          contrastText: '#fff',
        },
        info: {
          main: '#17A2B8',
          light: '#D1ECF1',
          dark: '#117A8B',
          contrastText: '#fff',
        },
        background: {
          default: '#FAF8FC', // Pastel purple-tinted background
          paper: '#ffffff',
        },
        text: {
          primary: '#2D2D3A',
          secondary: '#6B6B80',
          disabled: '#9E9EB0',
        },
        divider: '#E8E4ED',
        action: {
          hover: 'rgba(106, 53, 156, 0.04)',
          selected: 'rgba(106, 53, 156, 0.08)',
        },
      }
    : {
        // Dark mode - Pagali Brand Colors
        primary: {
          main: '#9060CB',
          light: '#B88ADE',
          dark: '#6233A0',
          contrastText: '#fff',
        },
        secondary: {
          main: '#CDD154',
          light: '#DEE26F',
          dark: '#B4BF09',
          contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        success: {
          main: '#66BB6A',
          light: '#81C784',
          dark: '#388E3C',
          contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        warning: {
          main: '#FFD54F',
          light: '#FFE082',
          dark: '#FFC107',
          contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        error: {
          main: '#EF5350',
          light: '#E57373',
          dark: '#D32F2F',
          contrastText: '#fff',
        },
        info: {
          main: '#4DD0E1',
          light: '#80DEEA',
          dark: '#00ACC1',
          contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        background: {
          default: '#1A1A2E',
          paper: '#25253E',
        },
        text: {
          primary: '#FFFFFF',
          secondary: '#B0B0C0',
          disabled: '#757585',
        },
        divider: '#3D3D5C',
        action: {
          hover: 'rgba(155, 99, 207, 0.08)',
          selected: 'rgba(155, 99, 207, 0.12)',
        },
      }),
});
